import { Directive, ElementRef, AfterViewInit, OnDestroy, Input, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Switch } from 'app/shared/components/ios-switch';

@Directive({
	selector: '[appToggle]'
})
export class ToggleDirective implements AfterViewInit, OnDestroy {

	mySwitch: any;
	private _isDisabled: boolean;
	@Input() set isDisabled(value: boolean) { this._isDisabled = value; this.updateToggle() };
	@Input() ngModel: boolean;
	initialValue: boolean;

	constructor(private elementRef: ElementRef, private ngControl: NgControl, private renderer: Renderer2) { }

	ngOnDestroy(): void {
		this.mySwitch.destroy();
	}

	ngAfterViewInit(): void {
		this.renderer.addClass(this.elementRef.nativeElement.parentElement, 'switch');
		this.renderer.addClass(this.elementRef.nativeElement.parentElement, 'switch-primary');
		this.mySwitch = new Switch(this.elementRef.nativeElement);
		if (this.ngModel)
			this.mySwitch.turnOn();

		this.mySwitch.el.addEventListener('click', (e) => {
			e.preventDefault();
			if (!this._isDisabled) {
				this.mySwitch.toggle();
			}
		}, false);
		this.ngControl.valueChanges.subscribe(x => this.updateToggle())
	}

	updateToggle(): void {
		if (this.mySwitch && !this._isDisabled) {
			if (this.ngControl.value)
				this.mySwitch.turnOn();
			else
				this.mySwitch.turnOff();
		}
	}
}
